import { Loader } from '../Loader'

import {
  ColorType,
  VariantType,
  SizeObject,
  SizeString,
  SizeType,
  ChildrenContainer,
  HTMLButton,
  LoaderContainer,
} from './Button.styled'

import type { JSX } from 'react'

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  isLoading?: boolean
  variant?: VariantType
  color?: ColorType
  size?: SizeType
}

export const Button = (props: Props): JSX.Element => {
  const defaultSize: SizeString = 'small'

  const {
    children,
    isLoading,
    disabled,
    variant = 'outline',
    color = 'neutral',
    size = defaultSize,
    type = 'submit',
    ...buttonProps
  } = props

  const isStringSize = typeof size == 'string'

  const formattedSize: SizeObject = {
    default: (isStringSize ? size : size.default) || defaultSize,
    mobile: isStringSize ? size : size.mobile,
    tablet: isStringSize ? size : size.tablet,
    desktop: isStringSize ? size : size.desktop,
  }

  // A loading button is locked: a second click would replay the action that is still running.
  return (
    <HTMLButton
      variant={variant}
      color={color}
      size={formattedSize}
      type={type}
      disabled={disabled || isLoading}
      focusableWhenDisabled={!!isLoading && !disabled}
      aria-busy={isLoading || undefined}
      {...buttonProps}
    >
      {isLoading && (
        <LoaderContainer>
          <Loader size={14} color="inherit" />
        </LoaderContainer>
      )}
      <ChildrenContainer isLoading={isLoading}>{children}</ChildrenContainer>
    </HTMLButton>
  )
}
